export default "__VITE_ASSET__CuzaNspf__"